

































































import { OlbButton, OlbIcon } from '@olbbank/vue-components';
import { defineComponent, onMounted, reactive } from '@vue/composition-api';
import axios from 'axios';
import PortalVue from 'portal-vue';
import Vue from 'vue';
Vue.use(PortalVue);

export default defineComponent({
	components: {
		OlbButton,
		OlbIcon,
	},
	props: {
		/**
		 * URL for Autocompletion
		 */
		suggestUrl: String,
		/**
		 * Event tracker
		 */
		etracker: String,
		/**
		 * Icon to be displayed as trigger
		 */
		searchIcon: {
			type: String,
			default: 'magnifier',
		},
		/**
		 * Label next to search icon for desktop viewport
		 */
		searchLabel: String,
		/**
		 * The route to be opened on submit
		 */
		formAction: String,
		/**
		 * Placeholder text for the input field
		 */
		placehtext: String,
		/**
		 * Value of the search input field
		 */
		inputValue: String,
		/**
		 * Name of the search input field
		 */
		inputName: String,
	},
	setup(props, { root }) {
		const state = reactive<{
			isActive: boolean;
			searchValue: string;
			suggestions: string[];
			selectedSuggestion: number;
			abortController: AbortController | null;
		}>({
			isActive: false,
			searchValue: props.inputValue || '',
			suggestions: [],
			selectedSuggestion: -1,
			abortController: null,
		});

		function toggleSearch() {
			state.suggestions = [];
			// when opening the search element:
			// hide the navi flyout, if it was open
			if (!state.isActive) {
				// eslint-disable-next-line @typescript-eslint/ban-ts-ignore
				//@ts-ignore
				root.$refs.navigation.setShowBackdrop(false);
			}
			state.isActive = !state.isActive;
		}

		/**
		 * Append any queries stated in the action attribute of the form to the request by appending a hidden input to the form.
		 * E.g. to filter the requests (used e.g. in THEOS search in the intranet)
		 */
		function afterBackdropOpen() {
			(document.querySelector('.olb-search-input') as HTMLInputElement).focus();
			// need to query for form instead of using a ref because refs aren't accessible in portals (see https://github.com/LinusBorg/portal-vue/issues/118)
			root.$nextTick(() => {
				const form = document.querySelector('.olb-search-form');
				const url = form?.getAttribute('action');
				let urlParts = url?.split('?');

				if (urlParts !== undefined && urlParts.length > 1) {
					form?.setAttribute('action', urlParts[0]);
					urlParts = urlParts[1].split('&');
					for (let i = 0; i < urlParts.length; i++) {
						const attribs = urlParts[i].split('=');
						const input = document.createElement('input');
						input.setAttribute('type', 'hidden');
						input.setAttribute('name', attribs[0]);
						input.setAttribute('value', attribs[1]);

						form?.prepend(input);
					}
				}
			});
		}

		function updateSuggestions() {
			if (!props.suggestUrl || !state.searchValue) {
				state.suggestions = [];
				state.selectedSuggestion = -1;
				return;
			}
			if (state.abortController) {
				state.abortController.abort();
			}

			state.abortController = new AbortController();
			axios
				.get(props.suggestUrl, {
					signal: state.abortController.signal,
					params: {
						q: state.searchValue,
					},
				})
				.then((res: { data: { suggestions: string[] } }) => {
					state.suggestions = res.data.suggestions;
					state.abortController = null;
				})
				.catch((error) => {
					if (error.message != 'canceled') {
						console.error(error);
					}
				});
		}

		function selectSuggestion(suggestion: string) {
			state.searchValue = suggestion;
		}

		function clickSelectSuggestion(suggestion: string) {
			selectSuggestion(suggestion);
			root.$nextTick(() => {
				const form = document.querySelector<HTMLFormElement>('.olb-search-form');

				if (form) {
					form.submit();
				}
			});
		}

		function handleKeydown(event: KeyboardEvent) {
			if (event.key !== 'ArrowDown' && event.key !== 'ArrowUp') {
				return;
			}
			if (event.key === 'ArrowDown' && state.selectedSuggestion < state.suggestions.length) {
				state.selectedSuggestion++;
				selectSuggestion(state.suggestions[state.selectedSuggestion]);
			}
			if (event.key === 'ArrowUp' && state.selectedSuggestion) {
				state.selectedSuggestion--;
				selectSuggestion(state.suggestions[state.selectedSuggestion]);
			}
		}

		onMounted(() => {
			root.$on('toggle-search', toggleSearch);
		});

		return {
			state,
			toggleSearch,
			afterBackdropOpen,
			updateSuggestions,
			selectSuggestion,
			clickSelectSuggestion,
			handleKeydown,
		};
	},
});
